module.exports = __webpack_public_path__ + "img/subscription-icon.466ff670.svg";